export const AI_PROMPT_MAX_LENGTH = 1_000;
export const ASSISTANT_PANEL_WIDTH_PX = 449;
export const ASSISTANT_PANEL_WIDTH_CLASS = 'w-[449px]';
export const ASSISTANT_PANEL_RESPONSIVE_WIDTH_CLASS = 'w-[300px] sm:w-[449px]';
